import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouteEvent } from '@commons/models/domain/RouteEvent';

import { RouteStats } from '@commons/models/domain/RouteStats';
import { RouteSummaryStats } from '@src/app/interfaces/route-stats.interface';
import { CalculateRouteSummaryParamsByStats } from '@src/app/utils/routes';

import { get } from 'lodash';

@Component({
  selector: 'app-vehicle-details-route-summary-data',
  templateUrl: './vehicle-details-route-summary-data.component.html',
  styleUrls: ['./vehicle-details-route-summary-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleDetailsRouteSummaryDataComponent {

  @Input() public isLoading: boolean;

  @Input('data') public set setData(data: RouteStats) {
    this._data = CalculateRouteSummaryParamsByStats(data);
  }

  @Input('routes') public set setRoutes(data: RouteEvent[] | undefined) {
    this.setStreets(data);
  }

  public _data!: RouteSummaryStats;
  public startLocationRoute: RouteEvent | null;
  public endLocationRoute: RouteEvent | null;

  constructor() { }

  private setStreets(data?: RouteEvent[]): void {
    if (data?.length) {
      const routesStreet = this.getFirstAndLastRouteStreet(data);
      console.log(routesStreet);
      if (routesStreet) {
        this.startLocationRoute = routesStreet.start;
        this.endLocationRoute = routesStreet.end;
      }
      return;
    }
    this.startLocationRoute = null!;
    this.endLocationRoute = null;
  }

  private getFirstAndLastRouteStreet(array: RouteEvent[]): { start: RouteEvent, end: RouteEvent } | null {
    if (!array.length) {
      return null;
    }
    const end = array[0];
    return {
      start: array[array.length-1],
      end,
    };
  }

}
